// Mock data for Adelaide Hills Tipper Hire

export const businessInfo = {
  name: "Adelaide Hills Tipper Hire",
  phone: "0467 022 863",
  email: "Hamish@adelaidehillstipperhire.com",
  address: "Adelaide Hills, SA",
  serviceArea: "Adelaide Hills, Murray Bridge & Surrounding Areas",
  hours: "Monday - Friday: 6:00 AM - 6:00 PM\nSaturday: 7:00 AM - 3:00 PM\nSunday: Closed"
};

export const services = [
  {
    id: 1,
    title: "Tandem Tipper Hire",
    description: "Professional tandem tipper trucks available for all your material delivery needs. Reliable and efficient service.",
    icon: "Truck",
    features: ["Steel Body Tandem Tippers", "Experienced Operators", "Flexible Scheduling", "Competitive Rates"]
  },
  {
    id: 2,
    title: "Material Delivery",
    description: "Delivery of soil, sand, gravel, and other materials to your site. Quick turnaround and professional service guaranteed.",
    icon: "Package",
    features: ["Various Materials", "Timely Delivery", "Load Capacity Options", "Site Assessment"]
  },
  {
    id: 3,
    title: "Site Preparation",
    description: "Professional site preparation services for residential and commercial projects. Additional trucks available upon request.",
    icon: "Construction",
    features: ["Residential Projects", "Commercial Sites", "Land Clearing", "Material Transport"]
  },
  {
    id: 4,
    title: "Waste Removal",
    description: "Efficient removal of excess dirt, rubble, and construction waste from your property. Clean and professional service.",
    icon: "Trash2",
    features: ["Green Waste", "Construction Waste", "Soil Removal", "Clean Service"]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_adelaide-tipper-hire/artifacts/5om7wlv9_unnamed.jpg",
    title: "Tandem Tipper Getting Loaded"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_adelaide-tipper-hire/artifacts/avvjuazs_unnamed%20%281%29.jpg",
    title: "Loading Skid Steer"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_adelaide-tipper-hire/artifacts/9ffdolkh_att.gyHG6KQB60wits0VxsTUKdEd8aAGa6SJRY-vNS1NaL4.JPG",
    title: "Tipper Truck on Site"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_adelaide-tipper-hire/artifacts/5559ownp_IMG_4334.jpeg",
    title: "Fleet at Work"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_adelaide-tipper-hire/artifacts/5qgd2p2e_IMG_4331%20%281%29.jpeg",
    title: "Material Transport"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "John Mitchell",
    company: "Mitchell Constructions",
    text: "Reliable service every time. The team is professional and their trucks are well-maintained. Highly recommend for any material delivery project.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Thompson",
    company: "Residential Client",
    text: "Needed soil delivered for a landscaping project. Quick response, fair pricing, and excellent service. Will definitely use again.",
    rating: 5
  },
  {
    id: 3,
    name: "David Chen",
    company: "Chen Developments",
    text: "We've been using Adelaide Hills Tipper for over a year. Their tandem tippers are perfect for our needs and the operators are experienced.",
    rating: 5
  }
];

// Store contact form submissions in browser localStorage
export const saveContactSubmission = (formData) => {
  const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  const newSubmission = {
    ...formData,
    id: Date.now(),
    submittedAt: new Date().toISOString()
  };
  submissions.push(newSubmission);
  localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
  return newSubmission;
};

export const getContactSubmissions = () => {
  return JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
};
